import React from 'react';
import { Mountain, Trees, Car, Heart, MapPin, Navigation } from 'lucide-react';

const LocationDescription = () => {
  const features = [
    {
      icon: Mountain,
      title: "Picturesque Landscape",
      description: "Nestled in nature overlooking the majestic Western Ghats"
    },
    {
      icon: Trees,
      title: "Serene & Silent",
      description: "Tranquil environment perfect for peaceful living"
    },
    {
      icon: Car,
      title: "Well Connected",
      description: "Easy access to city with wide roads and transport facilities"
    },
    {
      icon: Heart,
      title: "Natural Beauty",
      description: "Breath-taking views and fresh mountain air"
    }
  ];

  const mapData = {
    embedUrl: "https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3202.6866084411045!2d75.951883!3d11.448529999999998!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMTHCsDI2JzU0LjciTiA3NcKwNTcnMDYuOCJF!5e1!3m2!1sen!2sin!4v1766568398378!5m2!1sen!2sin",
    coordinates: "11.448529999999998,75.951883"
  };

  const handleDirectionsClick = () => {
    window.open(
      `https://www.google.com/maps/dir/?api=1&destination=${mapData.coordinates}`,
      '_blank'
    );
  };

  return (
    <section className="pt-10 pb-10 sm:pb-20 md:pt-20 bg-gray-50 overflow-hidden">
      <div className="container mx-auto px-4">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Text Content */}
          <div>
            <h2 className="text-4xl md:text-5xl font-light tracking-tight leading-tight mb-2">
              Discover Thamarasserry
            </h2>
            <p className="inline-flex items-center gap-2 text-[var(--primarycolor)] font-medium mb-6">
              <MapPin size={18} />
              Chamal Road, Malapuram, Thamarasserry, Calicut
            </p>
            
            <p className="text-lg text-gray-800 leading-relaxed mb-8">
              A picturesque landscaped locality nestled in nature overlooking the western ghats. 
              Experience serene and silent living in a location that offers the perfect balance 
              between peaceful countryside and urban convenience.
            </p>
            
            <div className="grid sm:grid-cols-2 gap-6">
              {features.map((feature, index) => (
                <div key={index} className="flex items-start space-x-4">
                  <div className="flex-shrink-0 w-12 h-12 bg-red-100 rounded-xl flex items-center justify-center">
                    <feature.icon className="w-6 h-6 text-[var(--primarycolor)]" />
                  </div>
                  <div>
                    <h3 className="font-medium text-gray-900 mb-1">
                      {feature.title}
                    </h3>
                    <p className="text-gray-700 text-sm">
                      {feature.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
          
          {/* Map */}
          <div className="bg-white rounded-2xl overflow-hidden border border-gray-300 ">
            {/* Map Header */}
            <div className="p-3 sm:p-4 bg-gray-50 border-b border-gray-200">
              <div className="flex flex-wrap gap-5 items-center justify-between">
                <div>
                  <h3 className="text-xl font-medium text-gray-900 flex items-center gap-3">
                    <MapPin className="w-5 h-5 text-[var(--primarycolor)]" />
                    Location
                  </h3>
                </div>
                
                {/* <button
                  onClick={handleDirectionsClick}
                  className="flex items-center gap-2 bg-[var(--primarycolor)] hover:bg-red-800 text-white px-4 py-2 rounded-lg font-medium transition-all duration-300 text-sm group"
                >
                  <Navigation className="w-4 h-4 group-hover:rotate-12 transition-transform duration-300" />
                  Get Directions
                </button> */}
              </div>
            </div>
            
            {/* Embedded Google Map */}
            <div className="h-80">
              <iframe 
                src={mapData.embedUrl}
                className="w-full h-full"
                style={{border:0}}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Thamarasserry Location"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LocationDescription;